module.exports = __webpack_public_path__ + "static/media/appstore_logo.364a447c.png";